<template>
    <div>
        <div class="lead border border-top-0 border-left-0 border-right-0 border-bottom text-left text-warning">
                EDIT ORDER # {{ $route.params.id }}           
            </div>
        <div>
            <div class="text-right mt-4">
                <small>
                    Просто хрень справа
                </small>
            </div>
                <div class="card mt-3 mb-4">
                    <div class="card-header bg-muted text-left pt-4 pb-2">
                        <div class="row justify-content-center">
                            <div class="col-md-5 text-dark pt-4">
                                <div class="row">
                                    <div class="col-sm-5">
                                        <small class="text-muted">Order Date:</small>
                                    </div>
                                    <div class="col-sm-7">
                                        {{ orderDate }}
                                    </div>
                                </div>
                                <div class="row" v-if="orderLastModDate">
                                    <div class="col-sm-5">
                                        <small class="text-muted">Last Modification Date:</small>
                                    </div>
                                    <div class="col-sm-7">
                                        {{ orderLastModDate }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                
                               <small class="text-muted">Came from:</small> <input placeholder="unknown location" v-model="cameFrom" class="form-control"> 
                               <small class="text-muted">Size:</small> <input placeholder="unknown size" v-model="tileSize" class="form-control">
                                
                            </div>
                            <div class="col-md-2 text-left text-dark">
                                <small class="text-muted">Order status:</small>
                                <select class="form-control "
                                        :class="status==0 ? 'text-danger' : 'text-success'"
                                        v-model="status">
                                    <option value="0" class="text-danger">Open</option>
                                    <option value="1" class="text-success">Done</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                    <!-- PERSONAL INFO -->
                        <div class="my-4 text-left">
                            <p class="lead text-dark">Personal info:</p>
                                <div class="row">
                                    <div class="col-md">
                                        <table class="table table-striped">
                                            <tr>
                                                <td><small class="text-muted">E-mail:</small></td>
                                                <td class="text-info"><input class="form-control" type="text" v-model="email"></td>
                                            </tr>
                                            <tr>
                                                <td><small class="text-muted">Animal:</small></td>
                                                <td class="text-info"><input class="form-control" type="text" v-model="animalType"></td>
                                            </tr>
                                            <tr v-if="uploadFiles">
                                                <td><small class="text-muted">Gallary Pix:</small><br>
                                                    <small class="text-danger">* DO NOT TOUCH</small>
                                                </td>
                                                <td class="text-info"><input class="form-control" type="text" v-model="gallaryName"></td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-md">
                                        <div class="card">
                                            <div class="card-body">
                                                <p><small class="text-muted">Message:</small></p>
                                                <textarea class="form-control" rows="5" v-model="description"></textarea>
                                            </div>
                                        </div>                                       
                                    </div>
                                </div>
                        </div>
                        <hr>
                    <!-- FONTS, LAYOUTS, SHILLUEST-->
                        <div class="my-4 text-left">
                            <p class="lead text-dark">Texts / Fonts / Layout / Ornaments:</p>
                                <div class="row">
                                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12">
                                        <table class="table table-responsive table-light table-striped table-hover">
                                            <tr>
                                                <td style="width:30%"><small class="text-muted">Animal In Memory Font:</small> <input class="form-control" v-model="animalMemoFont"></td>
                                                <td style="width:55%"><small class="text-muted">Text:</small> <input class="form-control" v-model="animalMemo"></td>
                                                <td style="width:15%"><small class="text-muted">Size: {{fontSizes.animalMemoSize}}</small>
                                                    <select class="form-control" id="sel-in-memo" v-model="fontSizes.animalMemoSize">
                                                        <option value="" selected>Select a size</option>
                                                        <option v-bind:value="option.value" 
                                                                v-for="(option, index) in sizes" 
                                                                :key="index">
                                                                {{option.key}}
                                                        </option> 
                                                    </select>                                 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><small class="text-muted">Animal Name Font:</small> <input class="form-control" v-model="animalNameFont"></td>
                                                <td><small class="text-muted">Text:</small> <input class="form-control" v-model="animalName"></td>
                                                <td><small class="text-muted">Size: {{fontSizes.animalNameSize}}</small> 
                                                    <select class="form-control" id="sel-in-name" v-model="fontSizes.animalNameSize">
                                                        <option value="" selected>Select a size</option>
                                                        <option v-bind:value="option.value" 
                                                                v-for="(option, index) in sizes" 
                                                                :key="index">
                                                                {{option.key}}
                                                        </option> 
                                                    </select>  
                                                </td> 
                                           </tr>
                                            <tr>
                                                <td><small class="text-muted">Animal Dates Font:</small> <input class="form-control" v-model="animalDatesFont"></td>
                                                <td><small class="text-muted">Text:</small> <input class="form-control" v-model="animalDates"></td>
                                                <td><small class="text-muted">Size: {{fontSizes.animalDatesSize}}</small> 
                                                    <select class="form-control" id="sel-in-dates" v-model="fontSizes.animalDatesSize">
                                                        <option value="" selected>Select a size</option>
                                                        <option v-bind:value="option.value" 
                                                                v-for="(option, index) in sizes" 
                                                                :key="index">
                                                                {{option.key}}
                                                        </option> 
                                                    </select>  
                                                </td>
                                            </tr>
                                            <tr>

                                                <td><small class="text-muted">Text On Monument</small><textarea class="form-control" v-model="animalText"></textarea></td>                                
                                                <td><small class="text-muted">Font:</small> <input class="form-control" v-model="animalTextFont"></td>                                                
                                                <td colspan="3"><small class="text-muted"></small></td> 
                                            </tr>
                                        </table>
                                    </div>
                                </div>

                                <div class="row my-4">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <div class="row">
                                            <div class="col-md">
                                                <div class="card">
                                                    <div class="card-header text-center text-muted">Current Layout</div>
                                                    <div class="card-body">
                                                        <div class="card-text">
                                                            <img class="img-fluid rounded mb-3" :src="'/static/img/layouts/' + layout" alt="Layout" />
                                                            <a class="btn btn-block btn-outline-danger" href="#" @click.prevent="changeLayoutBlock = !changeLayoutBlock">Change Layout</a><br>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                            </div>
                                            <div class="col-md">
                                                <div class="card">
                                                    <div class="card-header text-center text-muted">Ornaments</div>
                                                    <div class="card-body">
                                                        <div class="card-text"><textarea rows="3" class="form-control" v-model="ornaments"></textarea></div>
                                                    </div>
                                                </div>                                                
                                            </div>
                                            <div class="col-md" v-if="selectedDog != null && selectedDog != 'null'">
                                                <div class="card">
                                                    <div class="card-header text-muted">Dog Silhouette<br>
                                                        <small class="text-info">* Choose number from 1b to 9b.png</small>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="card-text text-center">
                                                            <input type="text" class="form-control mb-2" v-model="selectedDog">                                                            
                                                            <img class="img-fluid rounded" :src="'/static/img/dogs/' + selectedDog" alt=" selected dog" />
                                                        </div>
                                                    </div>
                                                </div>                                                
                                            </div>
                                            <div class="col-md" v-if="selectedCat != null && selectedCat != 'null'">
                                                <div class="card">
                                                    <div class="card-header text-muted">Cat Silhouette
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="card-text text-center">
                                                            <small class="text-info">* Choose number from 1b to 9b.png</small>
                                                            <input type="text" class="form-control mb-2" v-model="selectedCat">
                                                            <img class="img-fluid rounded" :src="'/static/img/cats/' + selectedCat" alt=" selected cat" />
                                                        </div>
                                                    </div>
                                                </div>                                                
                                            </div>                                            
                                        </div>
                                    </div>
                              </div>
                        </div>

                    <!-- LAYOUTS EDIT-->
                        <transition name="fade">
                            <div v-if="changeLayoutBlock" class="content-alignment my-5 text-muted">
                                <div class="row mb-5">
                                    <div class="col-md-4 col-sm-12" v-for="(layout, index) in layouts" :key="index">
                                        <div class="h6 text-center">{{ layout.title }}</div>
                                        <div @click="selectLayout(layout.nick)" :class="[{'layout-selected' : selectedLayout === layout.nick}, layout.nick]">
                                            <img class="img-fluid" v-bind:src="layout.lay_img" alt="Monument Layout">
                                        </div>
                                        <div class="layout-form-check" v-show="layout.lay_img_name === selectedLayout || selectedLayout === layout.nick">
                                            <i class="far fa-times-circle fa-2x" @click="selectedLayout = null"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <br>

                    <!-- PIX ACTIONS SECTION -->
                        <div class="my-4" v-if="uploadFiles">
                            <p class="lead text-info text-left">Uploaded user pictures</p>
                            <div class="card">
                                <div class="card-body">
                                    <div class="text-muted"> <small>Uploaded User Files Storage Location:</small> 
                                        <p class="text-dark">/static/img/uploads/{{gallaryName}}/{{uploadFiles}}</p>
                                    </div>                                   
                                        <div class="text-center my-4">
                                        <small class="text-left text-muted">Choose Action:</small><br>                                             
                                        <div class="btn-group" role="group" aria-label="pic-actions">
                                            <button class="btn btn-outline-danger" @click="pictureAcionPanelShow('all')">Delete All Pix & Directory</button>
                                            <button class="btn btn-outline-secondary" @click="pictureAcionPanelShow('single')">Delete Some Single Picture</button>
                                            <button class="btn btn-outline-success" @click="pictureAcionPanelShow('upload')">Upload More Pictures</button>
                                        </div>
                                    </div>  
                                    <transition name="fade">
                                        <div v-if="deleteAllPanel">
                                                <button class="btn btn-danger my-4 p-5" @click="deleteImagesDirectory"><h1>Fire!</h1></button>
                                        </div>                                    
                                    </transition>                                 
                                    <transition name="fade">
                                        <div v-if="deleteSinglePanel">
                                            <div class="row">
                                                <!-- ЛОКАЛЬНЫЕ ИМИДЖИ  -->
                                                    <div class="admin-images-holder 
                                                                col-md-3 
                                                                bg-dark 
                                                                mb-1 
                                                                text-center
                                                                border" v-for="(img, index) in imagesCompletePath" :key="index">
                                                        <div v-html="img"></div>
                                                        <i class="admin-image-delete text-white far fa-times-circle fa-2x" @click="deleteSingleImage(img)"></i>
                                                    </div> 
                                            </div>                                        
                                        </div>
                                    </transition>
                                    <transition name="fade">                                   
                                        <div v-if="uploadMorePixPanel">
                                                <p class="lead text-secondary my-5">Данная фича ещё не имплементирована!</p>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>

                    <!-- A COMPLITION DATE
                                    <div class="my-3">
                                        <div class="row">
                                            COMPLITION DATE  
                                                <div class="col-md-6 text-left">
                                                <p class="lead text-warning">Desired complition date:</p>
                                                <p class="lead text-danger" v-if="order.dateComplition != 'null'">{{ order.dateComplition }}</p>
                                                <p class="lead text-success" v-else>Не важно</p>
                                                <br>
                                            </div>

                                            USING ANIMAL PICTURE IN PORTFOLIO
                                            <div class="col-md-6 text-left">
                                                <p class="lead text-info">Using Animal Picture in Portfolio:
                                                <span class="lead text-success" v-if="order.usingPixInPortfolio">Можно</span>
                                                <span v-else class="lead text-danger">Нельзя</span></p>
                                            </div>
                                        </div>
                                    </div>
                                <hr> 
                            -->

                    <!-- EDITOR -->
                        <div class="my-5">
                            <p class="lead text-info text-left">Order notes</p>
                            <!-- <textarea class="form-control" v-model="orderMemo" cols="30" rows="10"></textarea> -->
                                    <app-editor api-key="33n28x1cdxlgzldiflue4944kydqr68cr4528y6tcbm7vv1c" 
                                                :init="{menubar: false, 
                                                plugins: ['advlist autolink lists link image charmap print preview anchor textcolor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table contextmenu paste code help wordcount'],
                                                toolbar: 'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
                                                content_css: ['//fonts.googleapis.com/css?family=Lato:300,300i,400,400i','//www.tinymce.com/css/codepen.min.css']}" 
                                                v-model="orderMemo">
                                    </app-editor> 
                        </div>
                        <div class="my-5">
                            <input class="btn btn-block btn-success p-4" @click.prevent="updateForm" type="submit" value="Update Order">
                        </div>
                    </div>
                </div>
            </div>
                    <!-- RESULT WINDOW  -->
                        <app-confirmation   @showDialogue="closeDialogue" 
                                            :successMessage="successMessage" 
                                            :errorMessage="errorMessage" 
                                            v-if="showingMessageModal" />       
    </div>
</template>

<script>
    import axios from 'axios'
    import Data from '@/data/data'
    import Editor from '@tinymce/tinymce-vue' 
    import conDialog from '@/components/Helpers/ConfirmationDialogue.vue'
        export default {
                components: {
                        appEditor: Editor,
                        'app-confirmation' : conDialog
                    },
                data(){
                    return {
                            apiURL: process.env.APP_API,
                            id: this.$route.params.id, 

                        // Images Action Panels
                            deleteSinglePanel: false,
                            deleteAllPanel: false,
                            uploadMorePixPanel : false,

                        // Messages & Dialog Windows
                            errorMessage: null,
                            successMessage: null,
                            showingMessageModal: false,

                        // Show Editing Blocks
                            changeLayoutBlock: false,

                            sizes: Data.sizes, 

                        // Order Properties
                            orderCurrent: {},
                            orderDate: '',
                            orderLastModDate: '',
                            uploadedImagesAdminPreview: [],
                            layouts: Data.layouts,
                            selectedLayout: '',
                            cameFrom: '',
                            tileSize: '',
                            status: false,
                            gallaryName: '',
                            imagesName: [],
                            imagesCompletePath: [],
                            email: '',
                            description: '',
                            animalType: '', 
                            animalMemo: '',
                            animalMemoFont: '',
                            animalName: '',
                            animalNameFont: '',
                            animalDates: '',
                            animalDatesFont: '',
                            animalText: '',
                            animalTextFont: '',
                                fontSizes: { 
                                    animalMemoSize: '',
                                    animalNameSize: '',
                                    animalDatesSize: '' 
                                },
                            layout: '',
                            dateComplition: '',
                            ornaments: '',
                            selectedDog: '',
                            selectedCat: '',
                            uploadFiles: '',
                            usingPixInPortfolio: false,
                            orderMemo: ''                                                 
                        }
                    },
                created(){
                    this.getCurrentOrder(this.$route.params.id)           
                    },
                methods: {
                        closeDialogue(status){
                                this.showingMessageModal = status
                            },
                        pictureAcionPanelShow(mode){
                            switch(mode) {
                                case 'single': 
                                        this.deleteSinglePanel = true
                                        this.deleteAllPanel = false
                                        this.uploadMorePixPanel = false                        
                                    break
                                case 'all':
                                        this.deleteSinglePanel = false
                                        this.deleteAllPanel = true
                                        this.uploadMorePixPanel = false                      
                                    break                        
                                case 'upload':
                                        this.deleteSinglePanel = false
                                        this.deleteAllPanel = false
                                        this.uploadMorePixPanel = true                      
                                    break 
                                }
                            },
                        getCurrentOrder(id){
                            axios.get(this.apiURL + '?action=readcurrent', {
                                params: {
                                id: id
                                }
                            })
                            .then((res) => {
                                if(res.data.error){
                                    this.errorMessage = res.data

                                } else {
                                    this.orderCurrent = res.data.order[0]
                                    // console.log('Наш заказ: ', this.orderCurrent)
                                    this.getSomeOrderProperties()
                                }
                            })
                            this.CurrentOrderView = true
                            },
                        getSomeOrderProperties(){
                            this.id = this.orderCurrent.id
                            this.orderDate = this.orderCurrent.order_date
                            this.cameFrom = this.orderCurrent.came_from
                            this.tileSize = this.orderCurrent.tile_size
                            this.gallaryName = this.orderCurrent.gallery_name
                            this.email = this.orderCurrent.email   
                            this.description = this.orderCurrent.description 
                            this.layout = this.orderCurrent.layout  
                            this.ornaments = this.orderCurrent.ornaments                             
                            this.selectedLayout = this.orderCurrent.layout
                            this.status = this.orderCurrent.status
                            this.orderLastModDate = this.orderCurrent.order_last_mod_date
                            this.selectedDog = this.orderCurrent.selected_dog
                            this.selectedCat = this.orderCurrent.selected_cat
                            this.animalType =  this.orderCurrent.animal_type 
                            this.animalMemo =  this.orderCurrent.animal_memo
                            this.animalMemoFont =  this.orderCurrent.animal_memo_font
                            this.animalName =  this.orderCurrent.animal_name
                            this.animalNameFont =  this.orderCurrent.animal_name_font
                            this.animalDates =  this.orderCurrent.animal_dates
                            this.animalDatesFont =  this.orderCurrent.animal_dates_font
                            this.fontSizes.animalMemoSize = this.orderCurrent.animal_memo_size
                            this.fontSizes.animalNameSize = this.orderCurrent.animal_name_size
                            this.fontSizes.animalDatesSize = this.orderCurrent.animal_dates_size 
                            this.animalText =  this.orderCurrent.animal_text
                            this.animalTextFont =  this.orderCurrent.animal_text_font
                            this.uploadFiles = this.orderCurrent.upload_files
                            this.orderMemo = this.orderCurrent.order_memo               
                        
                            this.completeImagesPathArrayBuilder(this.gallaryName, this.uploadFiles)
                            },
                        completeImagesPathArrayBuilder(gallaryName, imgNames){

                                // Режем имена файлов и складываем в архив
                                this.imagesName = imgNames.split(',')

                                for(var i = 0; i < this.imagesName.length; i++) {
                                var image = '<img class="img-fluid rounded" src="/static/img/uploads/'
                                    image += gallaryName + '/'
                                    image += this.imagesName[i]
                                    image += '">'  
                                    this.imagesCompletePath.push(image)
                                }
                            },
                        deleteSingleImage(image){

                            var ok = confirm("DELETE Image, серьёзно?")
                                if(ok){

                            //  УДАЛЯМ КАРТИНКИ ЛОКАЛЬНО      

                                // Полный путь в директорию
                                    var start = image.indexOf('/')
                                    var finish = image.lastIndexOf('"')
                                    var ImgDirPath = image.substring(start + 8, finish)
                                    // console.log('Путь в директорию: ', ImgDirPath)                        

                                // Имя картинки
                                    var startImageName = image.lastIndexOf('/')
                                    var finishImageName = image.lastIndexOf('"')
                                    var imageName = image.substring(startImageName + 1, finishImageName)  
                                    console.log('Имя удаляемого файла: ', imageName) 


                                // Выпиливаем имидж из архива имен из базы
                                    console.log('Upload files before cut: ', this.imagesName)
                                        var i = this.imagesName.indexOf(imageName)
                                                this.imagesName.splice(i, 1) 
                                    console.log('Upload files after cut: ', this.imagesName)                                    
                                
                                // Отправляем на сервер путь удаляемого и архив с именами картинок, переписать базу
                                    const formData = new FormData()
                                        formData.append('id', this.id)
                                        formData.append('imgDirPath', ImgDirPath)
                                        formData.append('imagesName', this.imagesName) 

                                        // axias не удаляет почему то, пускай повисит, пока что
                                                /* axios.delete(ImgDirPath)
                                                        .then((res)=> Console.log('Отличный результат!'))
                                                        .catch(error => {console.log('Фигня!!!')}) 
                                                    */

                                            axios.post(this.apiURL + '?action=deleteSingleImage', formData)
                                                .then((res) => {
                                                    this.successMessage = res.data
                                                    // console.log(res.data)

                                                    // Выпиливаем имидж из архива картиночек
                                                    var index = this.imagesCompletePath.indexOf(image)
                                                    this.imagesCompletePath.splice(index, 1) 

                                                })
                                                .catch(error => {
                                                    this.errorMessage = res.data
                                                    // console.log(res.data)                                        
                                                })
                                    }   
                            },

                        deleteImagesDirectory(){
                            var yes = confirm('DELETE ПАПКУ С ФОТКАМИ, серьёзно?')
                            if(yes){
                                var delDirectory = 'img/uploads/' + this.email
                                    const formData = new FormData()
                                        formData.append('id', this.id)
                                        formData.append('ImgDir', delDirectory)

                                                axios.post(this.apiURL + '?action=deleteImageDirectory', formData)
                                                    .then((res) => {
                                                        this.successMessage = res.data
                                                        this.imagesCompletePath = [] 
                                                        //window.location.reload
                                                    })
                                                    .catch(error => {
                                                        this.errorMessage = res.data                                       
                                                    })                    
                                    }
                            },
                        deleteOrder(id){
                                var del = confirm('Are you serious?')
                                if(del){
                                    const formData = new FormData()
                                    formData.append('id', id)

                                    axios.post(this.apiURL + '?action=delete', formData)
                                    .then((res) => {
                                        if(res.data.error){
                                            this.errorMessage = res.data
                                            console.log(res.data)
                                        } else {
                                            this.successMessage = res.data
                                            console.log(res.data)
                                            this.getAllOrders()
                                            this.getOpenOrders()
                                        }
                                    })
                                }
                            },
                        selectLayout(selected){
                            this.selectedLayout = selected;
                            switch(selected) {
                                    case "imgLeft":
                                        this.selectedLayout = 'image_on_left.jpg'
                                        break;
                                    case "imgRight":
                                        this.selectedLayout = 'image_on_right.jpg'
                                        break;                
                                    case "imgMiddle":
                                        this.selectedLayout = 'image_on_middle.jpg'
                                        break;
                                } 
                            },
                        updateForm(){
                            const formData = new FormData()

                            formData.append('id', this.id)
                            formData.append('cameFrom', this.cameFrom)
                            formData.append('tileSize', this.tileSize)
                            formData.append('status', this.status)                

                            formData.append('email', this.email)
                            formData.append('description', this.description)            
                            formData.append('animalType', this.animalType)
                            formData.append('gallaryName', this.gallaryName) 

                            formData.append('animalMemo', this.animalMemo)
                            formData.append('animalMemoFont', this.animalMemoFont)                 
                            formData.append('animalMemoSize', this.fontSizes.animalMemoSize)            
                    
                            formData.append('animalDates', this.animalDates)
                            formData.append('animalDatesFont', this.animalDatesFont)                
                            formData.append('animalDatesSize', this.fontSizes.animalDatesSize)            

                            formData.append('animalName', this.animalName)
                            formData.append('animalNameFont', this.animalNameFont)                
                            formData.append('animalNameSize', this.fontSizes.animalNameSize)            

                            formData.append('animalTextFont', this.animalNameFont)
                            formData.append('animalText', this.animalText)

                            formData.append('selectedDog', this.selectedDog)
                            formData.append('selectedCat', this.selectedCat)

                            formData.append('layout', this.selectedLayout)
                            formData.append('ornaments', this.ornaments)
                            formData.append('orderMemo', this.orderMemo)

                            // for(var item of formData){
                            //        console.log('На отправку!', item)
                            //    }  

                                const config = { 
                                    headers: { 'Content-Type':'multipart/form-data' } 
                                }

                               axios.post(this.apiURL + '?action=update', formData, config)
                                    .then((res) => {
                                        if(res.data.error){
                                            this.errorMessage = res.data.message
                                            this.showingMessageModal = true                                
                                        } else {
                                            this.successMessage = res.data.message
                                            this.showingMessageModal = true
                                                setTimeout(()=> {
                                                    this.showingMessageModal = false
                                                }, 2000)
                                                setTimeout(()=>{
                                                    this.$router.push({name: 'Orders'})
                                                }, 3000)                                                      
                                        }
                                    })
                        }
                    }
            }
</script>

<style>

.admin-images-holder {
    position:relative;
    max-height: 200px;
    overflow: hidden;
    border-radius: 5px;

}
.admin-image-delete {
    cursor:pointer;
    position: absolute;
    z-index: 1;
    top: 6px;
    right: 6px;
}
</style>





// WEBPACK FOOTER //
// src/components/Order/OrderEdit.vue